export default [
  {
    path: 'profile',
    title : "Настройки",
    card: true
  },
  {
    path: 'pay/list',
    title : "Список оплат"
  },
  {
    path: 'pay/:id',
    title : "Оплата подписки",
    props: true
  },
  {
    path: 'subscribe/list',
    title : "Список подписок"
  },
  {
    path: 'subscribe/remove/:id',
    card: false,
    title : "Отписка от канала",
    props: true
  }
]